export interface DataTableExportSelector<T> {
    name?: string,
    title?: string,
    export?: boolean,
    exportKey?: keyof T,
    exportFcn?: (row : T) => string,
    selector?: (row: T, rowIndex?: number) => string | number | boolean,
    data?: string
}
// From https://jbetancur.github.io/react-data-table-component/?path=/story/examples-export-csv--export-csv
// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
export function dataTableExport<T>(array: T[], selectors: DataTableExportSelector<T>[], format : "csv" | "tsv" = "csv", filename?: string) {
    const getValue = (obj: any, path: string) => path.split('.').reduce((acc, part) => acc && acc[part], obj);
    const link = document.createElement('a');
    let result : string;

    const columnDelimiter = format === "csv" ? ',' : '\t';
    const lineDelimiter = '\n';

    result = '';
    result += selectors.filter(x => x.exportKey || x.exportFcn || x.export).map(x => x.name || x.title || "").join(columnDelimiter);
    result += lineDelimiter;

    array.forEach(item => {
        let ctr = 0;
        selectors.forEach(selector => {
            if (ctr > 0) result += columnDelimiter;
            let toAppend;
            if (selector.export) {
                toAppend = selector.selector ? selector.selector(item) : (selector.data ? getValue(item, selector.data) : "");
            } else if (selector?.exportKey) {
                toAppend = item[selector.exportKey];
            } else if (selector?.exportFcn) {
                toAppend = selector.exportFcn(item);
            } else {
                // dont include this column
                return;
            }
            if (toAppend != null && typeof toAppend === "string") {
                if (toAppend.includes(",") || toAppend.includes('"') || toAppend.includes("\n")) {
                    toAppend = `"${toAppend.replace(/"/g, '""')}"`;
                }
            }
            result += toAppend;
            ctr++;
        });
        result += lineDelimiter;
    });

    if (result == null) return;

    filename = filename ? filename : `export.${format}`;

    const bom = "%EF%BB%BF"; // force excel to open UTF-8 properly
    if (!result.match(format === "csv" ? /^data:text\/csv/i : /^data:text\/tsv/i)) {
        result = `data:text/${format};charset=utf-8,${bom}${encodeURIComponent(result)}`;
    }

    link.setAttribute('href', result);
    link.setAttribute('download', filename);
    link.click();
}

// For use from classic non-bundled JS
declare global {
    interface Window {
        dataTableExport: typeof dataTableExport
    }
}
window.dataTableExport = dataTableExport
